import JobsPage from "./jobs-page";


const JobPages = {
    Collection : JobsPage
};

export default JobPages;
